export const GET_PROFILE_BY_REFERRAL_CODE = "GET_PROFILE_BY_REFERRAL_CODE"
export const GET_PROFILE_BY_REFERRAL_CODE_SUCCESS = "GET_PROFILE_BY_REFERRAL_CODE_SUCCESS"

export const GET_PROFILE_BY_REFERRAL_CODE_API_ERROR = "GET_PROFILE_BY_REFERRAL_CODE_API_ERROR"